export default __webpack_public_path__ + "images/13b8380caafad111308ec479bb33cd99-CPESync.svg";